import { axiosInstance } from 'boot/axios';
import NewsText from 'src/models/newsText.js';

export function getNewsTexts({ commit }) {
  return axiosInstance.get('News').then((response) => {
    commit(
      'setNewsTexts',
      response.data.map((newsText) => new NewsText(newsText)),
    );
  });
}

export function getNewsTextsBeforeAuthorization({ commit }) {
  return axiosInstance.get('News/BeforeAuthorization').then((response) => {
    commit(
      'setNewsTexts',
      response.data.map((newsText) => new NewsText(newsText)),
    );
  });
}

export function removeNewsTextById({ getters, commit }, id) {
  commit(
    'setNewsTexts',
    getters.newsTexts.filter((item) => item.id !== id),
  );
}
